import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Wallet_History - Get All (Read)
// export const GetAll = createAsyncThunk(
//   "masters/wallet-history/get-all",
//   async (filter, { rejectWithValue }) => {
//     try {
//       console.log(filter,"filter filter");

//       const res = await GET(
//         `${APIS.Wallet.Wallet_History}?}&search=${filter?.search || ""}&amount=${filter?.amount || ""}&from=${filter?.from}&to=${filter?.to}&payment_type_id=${filter?.payment_type_id || ""}&name=${filter?.name || ""}&page=${
//           filter?.page || IDS.PAGE
//         }&per_page=${filter?.per_page || IDS.PERPAGE}`
//       );
//       return res;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// Wallet_History - Get All (Read)
export const GetAll = createAsyncThunk(
  "wallethistory/wallet/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      // Logging the filter to check if it's constructed properly
      console.log("Filter:", filter);

      // Constructing the URL dynamically using the provided filters
      const res = await GET(
        `${APIS.Wallet.Wallet_History}?name=${filter?.name || ""}&search=${filter?.search || ""}&amount=${
          filter?.amount || ""
        }&from=${filter?.from || ""}&to=${filter?.to || ""}&payment_type_id=${
          filter?.paymenttype || ""
        }&&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      // Rejecting the request if an error occurs
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateWalletStatus = createAsyncThunk(
  "wallethistory/wallet/update-status",
  async ({ id, status_id }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Wallet.Wallet_History}/${id}`, {
        transaction_status_id: status_id,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "wallethistory",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateWalletStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateWalletStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (country) => country.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateWalletStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
